import { ExtrudeSymbol3DLayer, ObjectSymbol3DLayer, PointSymbol3D, PolygonSymbol3D } from "@arcgis/core/symbols";
import SolidEdges3D from "@arcgis/core/symbols/edges/SolidEdges3D.js";
import { symbologyColors } from "./colors";

export const defaultHeight = 0.02
export const defaultHeight_symbol = 0.02


export const roofHighLightedSymbol = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight_symbol,
      material: {
        color: [...symbologyColors.roof_border, 0.8]
      },
      edges: new SolidEdges3D({
        size: 5,
        color: [...symbologyColors.highlight_border, 1]
      })
    })
  ]
});


export const buildingSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.roof, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.roof_border, 1]
      })
    })
  ]
});
export const buildingSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.roof, 0.2]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.roof, 1]
        })
      })
    ]
  })
};

export const columnsSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.extendedColumns, 0.5] // gray
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.extendedColumns, 1]
      })
    })
  ]
});
export const columnsSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.extendedColumns, 0.5]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.extendedColumns, 1]
        })
      })
    ]
  })
};

export const metalSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.metal, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.metal, 1]
      })
    })
  ]
});
export const metalSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.metal, 0.4]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.metal, 1]
        })
      })
    ]
  })
};

export const InverterSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.inverter, .4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.inverter, 1]
      })
    })
  ]
});
export const InverterSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.inverter, .4]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.inverter, 1]
        })
      })
    ]
  })
};

export const helipadSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [ ...symbologyColors.helipad, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [ ...symbologyColors.helipad, 1]
      })
    })
  ]
});
export const helipadSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [ ...symbologyColors.helipad, 0.4]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [ ...symbologyColors.helipad, 1]
        })
      })
    ]
  })
};

export const chimneySymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.chimney, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.chimney, 1]
      })
    })
  ]
});
export const chimneySymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.chimney, 0.4]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.chimney, 1]
        })
      })
    ]
  })
};

export const skylightSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.skylight, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.skylight, 1]
      })
    })
  ]
});
export const skylightSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.skylight, 0.4]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.skylight, 1]
        })
      })
    ]
  })
};

export const mobileTowerSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.mobileTower, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.mobileTower, 1]
      })
    })
  ]
});
export const mobileTowerSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.mobileTower, 0.4]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.mobileTower, 1]
        })
      })
    ]
  })
};

export const ridgeSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.ridge, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.ridge, 1]
      })
    })
  ]
});

export const ridgeSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.ridge, 0.4]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.ridge, 0.1]
        })
      })
    ]
  })
};


//  (Gray, symbolizing concrete or neutral tones)
export const parapetSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.parapetWall, 0.5]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.parapetWall, 0.1]
      })
    })
  ]
});
export const parapetSymbologyHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.parapetWall, 0.5]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.parapetWall, 1]
        })
      })
    ]
  })
};

export const acearthSymbol = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.ac_earthing, 0.5]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.ac_earthing, 0.8]
      })
    })
  ]
});

export const acearthSymbolHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.ac_earthing, 0.5]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.ac_earthing, 0.8]
        })
      })
    ]
  })
};

export const dcearthSymbol = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.dc_earthing, 0.8]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.dc_earthing, 1]
      })
    })
  ]
});
export const dcearthSymbolHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.dc_earthing, 0.8]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.dc_earthing, 1]
        })
      })
    ]
  })
};

export const pipelineSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.pipelines, 0.7]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.pipelines, 1]
      })
    })
  ]
});
export const pipelineSymbologywithHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.pipelines, 0.7]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.pipelines, 1]
        })
      })
    ]
  })
};

// Golden 
export const lightningSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color:[...symbologyColors.lightningArrester, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.lightningArrester, 1]
      })
    })
  ]
});
export const lightningSymbologywithHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.lightningArrester, 0.4]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.lightningArrester, 1]
        })
      })
    ]
  })
};

export const symbolforColredHeight = (height: number, color: number[]) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: color
        },
        edges: new SolidEdges3D({
          size: 2,
          color: color
        })
      })
    ]
  })
};

// export const hvacSymbologywithHeight = (height: number) => {
//   return new PolygonSymbol3D({
//     symbolLayers: [
//       new ExtrudeSymbol3DLayer({
//         size: height,
//         material: {
//           color: [...symbologyColors.hvac, 0.5]
//         },
//         edges: new SolidEdges3D({
//           size: 2,
//           color: [...symbologyColors.hvac, 1]
//         })
//       })
//     ]
//   })
// };
export const solarPaneExistingSymbologywithHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.hvac, 0.5]
        },
        edges: new SolidEdges3D({
          size: 2,
          color: [...symbologyColors.hvac, 1]
        })
      })
    ]
  })
};



export const mumtyStructureSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight_symbol,
      material: {
        color: [...symbologyColors.mumty_structure, 0.5]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.mumty_structure, 1]
      })
    })
  ]
});
export const mumtyStructureSymbologywithHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.mumty_structure, 0.5]
        },
        edges: new SolidEdges3D({
          size: 0.1,
          color: [...symbologyColors.mumty_structure, 1]
        })
      })
    ]
  })
};


export const treeSymbol = {
  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
  url: "https://static.arcgis.com/images/Symbols/Shapes/BlackStarLargeB.png",
  width: "64px",
  height: "64px"
} as any

export const InfraSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.others, 0.2]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.others, 1]
      })
    })
  ]
});

 
export const walkwaySymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.walkway, 0.2]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.walkway, 1]
      })
    })
  ]
});
export const walkwaySymbologyHeight = (height: number) =>  {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.walkway, 0.2]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [...symbologyColors.walkway, 1]
        })
      })
    ]
  })
};

export const lifelineSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.lifeline, 0.2]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.lifeline, 1]
      })
    })
  ]
});
export const lifelineSymbologyHeight = (height: number) =>  {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.lifeline, 0.2]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [...symbologyColors.lifeline, 1]
        })
      })
    ]
  })
};

export const waterTankSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.waterStorageTank, 0.5]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.waterStorageTank, 1]
      })
    })
  ]
});
export const waterTankSymbologyHeight = (height: number) =>  {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.waterStorageTank, 0.5]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [...symbologyColors.waterStorageTank, 1]
        })
      })
    ]
  })
};

export const hvacSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.hvac, 0.7] // bright cool blue]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.hvac, 1] // bright cool blue
      })
    })
  ]
});
export const hvacSymbologyHeight = (height: number) =>  {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.hvac, 0.7] // bright cool blue]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [...symbologyColors.hvac, 1] // bright cool blue
        })
      })
    ]
  })
};

export const modulecleaningpipeSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.moduleCleaningPipe, 0.5]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.moduleCleaningPipe, 1] 
      })
    })
  ]
});
export const modulecleaningpipeSymbologyHeight = (height: number) =>  {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.moduleCleaningPipe, 0.5]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [...symbologyColors.moduleCleaningPipe, 1] 
        })
      })
    ]
  })
};

export const handrailsSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.moduleCleaningPipe, 0.5] // bright cool blue]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.moduleCleaningPipe, 1] // bright cool blue
      })
    })
  ]
});
export const handrailsSymbologyHeight = (height: number) =>  {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.handrails, 0.5] // bright cool blue]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [...symbologyColors.handrails, 1] // bright cool blue
        })
      })
    ]
  })
};

// existing solar modules
export const solarModuleSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: 0.002,
      material: {
        color: [...symbologyColors.exisistingmodules, 0.5]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.exisistingmodules, 1]
      })
    })
  ]
});

export const solarModuleSymbologyWithHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height, // extrude by 3.5m meters
        material: {
          color: [...symbologyColors.exisistingmodules, 0.5]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [...symbologyColors.exisistingmodules, 1]
        })
      })
    ]
  })
}


export const solarPanelsSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [0, 0, 75, 0.4]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [128, 128, 128, 0.5]
      })
    })
  ]
});

export const updateElevationSymbology = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [0, 0, 75, 0.4]
        },
        edges: new SolidEdges3D({
          size: 0,
          color: [128, 128, 128, 0.5]
        })
      })
    ]
  })
};

export const updatedSymbolWithHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height, // extrude by 3.5m meters
        material: {
          color: [255, 255, 255, 0.4]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [82, 82, 122, 1]
        })
      })
    ]
  })
}

export const solarPanelsWithString = (color: number[]) =>  new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: 0.08,
      material: {
        color: [...color]
      },
      edges: new SolidEdges3D({
        size: 0,
        color: [...color]
      })
    })
  ]
})

export const solarPanlesBlueSymbol =  new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: 0.08,
      material: {
        color: [...symbologyColors.panels, 0.8]
      },
      edges: new SolidEdges3D({
        size: 0,
        color: [...symbologyColors.panels, 0.8]
      })
    })
  ]
})

export const solarPanlesRedSymbol =  new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: 0.08,
      material: {
        color: [255, 0, 0, 0.9]
      },
      edges: new SolidEdges3D({
        size: 0,
        color: [255, 255, 255]
      }),
    }),
    
  ]
})



export const roofSymbology = new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: 0,
      material: {
        color: [...symbologyColors.roof, 0.4]
      },
      edges: new SolidEdges3D({
        size: 1,
        color: [...symbologyColors.roof, 1]
      })
    })
  ]
});

export const roofSymbologywithHeight = (height: number) => {
  return new PolygonSymbol3D({
    symbolLayers: [
      new ExtrudeSymbol3DLayer({
        size: height,
        material: {
          color: [...symbologyColors.roof, 0.4]
        },
        edges: new SolidEdges3D({
          size: 1,
          color: [...symbologyColors.roof, 1]
        })
      })
    ]
  })
}

export const treeSymbology = (height: number) =>  new PointSymbol3D({
  symbolLayers: [
    new ObjectSymbol3DLayer({
      resource: {
        href: "https://static.arcgis.com/arcgis/styleItems/ThematicTrees/gltf/resource/PlatanusOccidentalis.glb"
      },
      height
    })
  ]
});
export const treeSymbology_2d = (height: number) =>  new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: defaultHeight,
      material: {
        color: [...symbologyColors.trees, 0.4]
      },
      edges: new SolidEdges3D({
        size: 2,
        color: [...symbologyColors.trees, 1]
      })
    })
  ]
});

export const symb_simple = {
  type: "simple-fill",  // autocasts as new SimpleFillSymbol()
  color: [0, 0, 75, 0.4],
  outline: { 
    color: [128, 128, 128, 0.5],
    width: "0.5px"
  }
};


export const panleSymbology = (color: number[]) =>  new PolygonSymbol3D({
  symbolLayers: [
    new ExtrudeSymbol3DLayer({
      size: 0.08,
      material: {
        color: [0, 0, 75, 0.4]
      },
      edges: new SolidEdges3D({
        size: 0,
        color: [128, 128, 128, 0.5]
      })
    })
  ]
})

export const simpleMarkerSymbol = {
  type: "simple-marker",
  color: [226, 119, 40],  // Orange
  outline: {
      color: [255, 255, 255], // White
      width: 1
    }
}